import { InsightCard } from './insight-card'
import { CategoryVariant } from './category-marker'
import type { Insight } from '../types'
import { InsightsTab } from '../utils'
import './insight-section.scss'
import { NoData } from '../no-data/no-data'

export interface InsightCategory {
    variant: CategoryVariant
    label: string
}

export interface InsightSectionProps {
    headingId: string
    heading: string
    insights: Insight[]
    tab: InsightsTab
    /**
     * Optional per-insight category lookup. If omitted, cards render without
     * a category marker (used for sections where every insight belongs to the
     * same implicit category, e.g. "Yesterday at a glance").
     */
    getCategory?: (insight: Insight) => InsightCategory | undefined
}

export const InsightSection = ({
    headingId,
    heading,
    insights,
    tab,
    getCategory,
}: InsightSectionProps) => (
    <section className="insight-section" aria-labelledby={headingId}>
        <h2 id={headingId} className="hc8-mb-3x hc8-fs-250 hc8-clr-base">
            <strong>{heading}</strong>
        </h2>
        <div className="insight-section__cards">
            {insights.length === 0 ? (
                <NoData />
            ) : (
                insights.map((insight, index) => (
                    <InsightCard
                        key={insight.title}
                        title={insight.title}
                        summary={insight.summary}
                        index={index}
                        tab={tab}
                        insightIcon={insight.insight_icon}
                        // TODO: once we broaden the scope of what we show on these pages, add this back in
                        // category={getCategory?.(insight)}
                    />
                ))
            )}
        </div>
    </section>
)
